<!--
 * @Description: 设计小票模板
 * @Author: Roger Wei
 * @Date: 2021-11-23 17:38:09
 * @LastEditTime: 2021-11-30 17:33:30
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
-->
<template>
    <div class="pages_content table">
        <div class="header-area">
            <span style="font-size: 15px; font-weight: bold;">{{ title }} </span>
            <el-button class="bottom_all" @click="submitTicket">发&nbsp;布</el-button>
        </div>
        <el-form :inline="true" :rule="[]" :model="form" class="demo-form-inline">
            <el-form-item label="模板名称">
                <el-input v-model="form.templateName" placeholder="请输入" required></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="form.remark" placeholder="请输入"></el-input>
            </el-form-item>
        </el-form>
        <div class="design-area">
            <el-row :gutter="10">
                <el-col :span="2">
                    <div class="header-title">控件库</div>
                    <div class="operation-area">
                        <div v-for="item in controlList" :key="item.key" class="control-item" draggable="true"
                            @dragend="onDrop" @dragstart="onDragStart(item, $event)">
                            {{ item.label }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="header-title">
                        画布尺寸：长:<input v-model="canvasSize.x" style="width: 50px;" type="text" class="canvas-input">cm,
                        宽：<input v-model="canvasSize.y" style="width: 50px;" type="text" class="canvas-input">cm；
                        整体偏移：水平：<input v-model="moveX" style="width: 50px;" type="number" class="canvas-input"
                            @blur="changeDataList">cm,垂直：<input v-model="moveY" style="width: 50px;" type="number"
                            class="canvas-input" @blur="changeDataList">cm;
                        图片透明度:<input v-model="imgOpacity" style="width: 50px;" type="number" class="canvas-input">
                        图片可选:<el-switch v-model="imgSelect" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        文本控件字体:<input v-model="textControlFont" style="width: 50px;" type="number" class="canvas-input"
                            @blur="changeTextControlFont">px
                        <el-dropdown style="margin-left: 10px;" @command="deleteControl">
                            <el-link type="danger" :underline="false">删除</el-link>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in controlList" :key="index" :command="item.type">{{
                                    item.label }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button class="bottom_all" @click="print()">打&nbsp;印</el-button>
                    </div>
                    <div ref="draw-block" class="operation-area"
                        style=";padding 0; border: 1px solid #f3f3f3;height: 60vh; overflow: auto;">
                        <div class="canvas-area" style="position:relative; border: 1px solid #ddd; "
                            :style="{ width: canvasSize.x + 'cm', height: canvasSize.y + 'cm' }">
                            <div v-for="(item, index) in dataList" :key="index"
                                :style="{ left: item.attr.left / cmUnit + 'cm', top: item.attr.top / cmUnit + 'cm', zIndex: item.type === 'image' ? 1 : 99, pointerEvents: item.type === 'image' && !imgSelect ? 'none' : '' }"
                                class="ticket-item" style="position: absolute; display: inline;"
                                :class="{ 'active-item': index === curIndex }" :tabindex="index == curIndex ? 1 : -1"
                                @mousedown="onMouseDown(item, $event)" @mousemove="onMouseMove" @mouseup="onMouseUp"
                                @keydown="handleKeydown(index, $event)" @click="chosenItem(index, $event)">
                                <!-- 文本控件 -->
                                <div v-if="item.type === 'text'" :style="{
                                    fontSize: item.attr.fontSize + 'px',
                                    width: item.attr.width + 'cm',
                                    fontWeight: item.attr.fontWeightBold ? 'bold' : 'normal',
                                    fontStyle: item.attr.fontStyleItalic ? 'italic' : 'normal',
                                    textDecoration: item.attr.textDecorationUnderLine ? 'underline' : 'normal'
                                }">
                                    {{ item.value }}
                                </div>
                                <!-- 图片控件 -->
                                <div v-if="item.type === 'image'"
                                    :style="{ width: item.attr.width + 'cm', opacity: imgOpacity }">
                                    <img v-if="item.value" :src=" printFileUrl  + item.value" alt=""
                                        :style="{ width: item.attr.width + 'cm' }">
                                    <span v-else>图片控件</span>
                                </div>
                                <!-- 二维码控件 -->
                                <div v-if="item.type === 'qrcode'" :style="{ width: item.attr.width + 'cm' }">
                                    <span
                                        v-if="(item.dataAttr.type === 'fixed' && !item.value) || (item.dataAttr.type === 'custom' && !item.dataAttr.dataSource.length)">二维码控件</span>
                                    <genQrCode v-else :item="item"></genQrCode>
                                </div>
                                <!-- 横线控件 -->
                                <div v-if="item.type === 'horizontalLine'" :style="{
                                    background: '#000', height: item.attr.height + 'px',
                                    width: item.attr.width + 'cm'
                                }"></div>
                                <!-- 竖线控件 -->
                                <div v-if="item.type === 'verticalLine'" :style="{
                                    background: '#000', height: item.attr.height + 'cm',
                                    width: item.attr.width + 'px'
                                }"></div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="header-title">自定义控件</div>
                    <div v-if="curIndex >= 0" class="operation-area">
                        <!-- 文本配置 -->
                        <div v-if="dataList[curIndex].type === 'text'" style="line-height: 3;">
                            <div>坐标X:
                                <el-input v-model="dataList[curIndex].attr.left" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>坐标Y:
                                <el-input v-model="dataList[curIndex].attr.top" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>内容长度:
                                <el-input v-model="dataList[curIndex].attr.width" style="width: 80px;"></el-input>cm
                            </div>
                            <div>字体大小:
                                <el-input v-model="dataList[curIndex].attr.fontSize" style="width: 80px;"></el-input>px
                            </div>
                            <div>字体样式:
                                <el-checkbox v-model="dataList[curIndex].attr.fontWeightBold">加粗</el-checkbox>
                                <el-checkbox v-model="dataList[curIndex].attr.fontStyleItalic">斜体</el-checkbox>
                                <el-checkbox v-model="dataList[curIndex].attr.textDecorationUnderLine">下划线</el-checkbox>
                            </div>
                            <div>
                                数据类型：
                                <el-select v-model="dataList[curIndex].dataAttr.type">
                                    <el-option label="固定文本" value="fixed"></el-option>
                                    <el-option label="自定义数据" value="custom"></el-option>
                                </el-select>
                            </div>
                            <div v-if="dataList[curIndex].dataAttr.type === 'fixed'">
                                文本内容：
                                <el-input v-model="dataList[curIndex].value" placeholder="请输入固定文本"
                                    maxlength="50"></el-input>
                            </div>
                            <div v-else>
                                数据来源：
                                <el-select v-model="dataList[curIndex].dataAttr.dataSource">
                                    <el-option v-for="item in dataSource" :key="item.key" :label="item.label"
                                        :value="item.key"></el-option>
                                </el-select>
                            </div>

                        </div>
                        <!-- 图片配置 -->
                        <div v-if="dataList[curIndex].type === 'image'" style="line-height: 3;">
                            <div>坐标X:
                                <el-input v-model="dataList[curIndex].attr.left" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>坐标Y:
                                <el-input v-model="dataList[curIndex].attr.top" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>图片宽度:
                                <el-input v-model="dataList[curIndex].attr.width" style="width: 80px;"></el-input>cm
                            </div>

                            <FileComponent fileCode="TicketImg" :files="fileList" @deleteFile="delFile"
                                @uplodeSuccess="uploadSuccess" />
                        </div>
                        <!-- 二维码配置 -->
                        <div v-if="dataList[curIndex].type === 'qrcode'" style="line-height: 3;">
                            <div>坐标X:
                                <el-input v-model="dataList[curIndex].attr.left" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>坐标Y:
                                <el-input v-model="dataList[curIndex].attr.top" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>图片宽度:
                                <el-input v-model="dataList[curIndex].attr.width" style="width: 80px;"
                                    @change="setQrCode"></el-input>cm
                            </div>
                            <div>
                                数据类型：
                                <el-select v-model="dataList[curIndex].dataAttr.type">
                                    <el-option label="固定文本" value="fixed"></el-option>
                                    <el-option label="自定义数据" value="custom"></el-option>
                                </el-select>
                            </div>
                            <div v-if="dataList[curIndex].dataAttr.type === 'fixed'">
                                文本内容：
                                <el-input v-model="dataList[curIndex].value" placeholder="请输入固定文本" maxlength="20"
                                    @change="setQrCode"></el-input>
                            </div>
                            <div v-else>
                                数据来源：
                                <el-select v-model="dataList[curIndex].dataAttr.dataSource" multiple @change="setQrCode">
                                    <el-option v-for="item in dataSource" :key="item.key" :label="item.label"
                                        :value="item.key"></el-option>
                                </el-select>
                            </div>

                        </div>
                        <!-- 横线配置 -->
                        <div v-if="dataList[curIndex].type === 'horizontalLine'" style="line-height: 3;">
                            <div>坐标X:
                                <el-input v-model="dataList[curIndex].attr.left" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>坐标Y:
                                <el-input v-model="dataList[curIndex].attr.top" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>宽度:
                                <el-input v-model="dataList[curIndex].attr.width" style="width: 80px;"></el-input>cm
                            </div>
                            <div>高度:
                                <el-input v-model="dataList[curIndex].attr.height" style="width: 80px;"></el-input>px
                            </div>

                        </div>
                        <!-- 竖线配置 -->
                        <div v-if="dataList[curIndex].type === 'verticalLine'" style="line-height: 3;">
                            <div>坐标X:
                                <el-input v-model="dataList[curIndex].attr.left" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>坐标Y:
                                <el-input v-model="dataList[curIndex].attr.top" type="number"
                                    style="width: 120px;"></el-input>px
                            </div>
                            <div>高度:
                                <el-input v-model="dataList[curIndex].attr.height" style="width: 80px;"></el-input>cm
                            </div>
                            <div>宽度:
                                <el-input v-model="dataList[curIndex].attr.width" style="width: 80px;"></el-input>px
                            </div>

                        </div>

                        <el-button type="danger" size="small" style="width: 80%; margin-left: 10%;margin-top: 10px;"
                            @click="delControl">删&nbsp;&nbsp;&nbsp;&nbsp;除</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import FileComponent from '@/components/File/fileComponent';
import QRCode from 'qrcodejs2'
import TicketConf from '@/utils/ticketConf'
import genQrCode from './components/genQrCode'
// API
import { saveOrUpdateTicketTemplate } from "@/api/basicConfig/ticketTemplate"
export default {
    name: 'edit-ticket-template',
    components: { FileComponent, genQrCode },
    data() {
        return {
            title: '新增模板',
            isDebug: true,
            dragData: false,
            form: {
                templateName: '',
                remark: '',
                secondLevelMenuKey: '',
                firstLevelMenuKey: ''
            },
            printFileUrl : process.env.VUE_APP_API_Print_File,
            dataSource: [],
            cmUnit: 37.78,
            // cmUnit: 28,
            // 1厘米等于px
            canvasSize: {  // 画布尺寸
                x: 20,
                y: 30
            },
            controlList: [{
                type: 'text',
                label: '文本控件',
                model: {
                    type: 'text',
                    attr: {
                        left: 0,
                        top: 0,
                        fontSize: '15',
                        width: 5,
                        fontWeightBold: false,
                        fontStyleItalic: false,
                        textDecorationUnderLine: false,
                    },
                    value: '文本控件',
                    dataAttr: {
                        type: 'fixed',  // custom
                        dataSource: ''
                    }
                }
            },
            {
                type: 'image',
                label: '图片控件',
                model: {
                    type: 'image',
                    attr: {
                        left: 0,
                        top: 0,
                        width: 5,
                    },
                    value: '',
                }
            },
            {
                type: 'qrcode',
                label: '二维码控件',
                model: {
                    type: 'qrcode',
                    attr: {
                        left: 0,
                        top: 0,
                        width: 5,
                    },
                    value: '',
                    dataAttr: {
                        type: 'fixed',  // custom
                        dataSource: []
                    }
                }
            },
            {
                type: 'horizontalLine',
                label: '横线控件',
                model: {
                    type: 'horizontalLine',
                    attr: {
                        left: 0,
                        top: 0,
                        width: 5,  // cm
                        height: 1
                    }
                }
            },
            {
                type: 'verticalLine',
                label: '竖线控件',
                model: {
                    type: 'verticalLine',
                    attr: {
                        left: 0,
                        top: 0,
                        width: 1,
                        height: 2   // cm
                    }
                }
            }
            ],
            dataList: [],

            // 拖动事件
            moveData: {
                item: false,
                point: false
            },
            // 选中item
            curIndex: -1,
            curDom: false,
            // 图片上传
            fileList: [],
            moveX: 0,
            moveY: 0,
            imgOpacity: 1,
            imgSelect: true,
            textControlFont: "",
        }
    },
    mounted() {
        /*  console.log(this.$route.query) */
        let query = this.$route.query
        if (!query.form) {   // 新增
            this.form.firstLevelMenuKey = query.parentKey
            this.form.secondLevelMenuKey = query.key
            this.form.secondLevelMenuName = query.label
            this.dataSource = query.dataSourceList
            this.title = '新增模板'
        } else {  // 编辑或者复制
            this.form = JSON.parse(decodeURIComponent(query.form))
            /* console.log(this.form) */
            let data = JSON.parse(this.form.content)
            if (data.dataList) {
                this.dataList = data.dataList
            }
            if (data.canvasSize) {
                this.canvasSize = data.canvasSize
            }
            if (this.form.id) {
                this.title = '编辑模板'
            } else {
                this.title = '复制模板'
            }
            // 设置datasource
            let ticketItem = TicketConf.filter(item => {
                return item.key === this.form.firstLevelMenuKey
            }) // 一节
            if (ticketItem.length) {
                ticketItem = ticketItem[0].children.filter(item => {
                    return item.key === this.form.secondLevelMenuKey
                })

                if (ticketItem.length) {
                    this.dataSource = ticketItem[0].dataSourceList
                }
            }

        }
        //打印组件初始化
        this.$pluginName.init({
            host: "http://localhost:17521", // 打印客户端的地址
            token: "icpsPrint", // 与打印客户端相同的 token
        });
    },
    methods: {
        //键盘事件
        handleKeydown(index, event) {
            console.log(event)
            if (event.key === 'w') {
                this.dataList[index].attr.top = this.dataList[index].attr.top * 1 - 1
            } else if (event.key === 's') {
                this.dataList[index].attr.top = this.dataList[index].attr.top * 1 + 1
            } else if (event.key === 'a') {
                this.dataList[index].attr.left = this.dataList[index].attr.left * 1 - 1
            } else if (event.key === 'd') {
                this.dataList[index].attr.left = this.dataList[index].attr.left * 1 + 1
            }
        },
        //改变所有文本控件字体
        changeTextControlFont() {
            this.dataList.forEach(item => {
                if (item.type == 'text') {
                    item.attr.fontSize = this.textControlFont
                }
            })
            this.textControlFont = ''
        },
        //删除所有指定类型控件
        deleteControl(type) {
            this.dataList = this.dataList.filter(item => item.type !== type);
        },
        //整体移动
        changeDataList() {
            if (this.moveX) {
                this.dataList.forEach(item => {
                    item.attr.left = item.attr.left + this.moveX * this.cmUnit
                })
                this.moveX = 0
            }
            if (this.moveY) {
                this.dataList.forEach(item => {
                    item.attr.top = item.attr.top + this.moveY * this.cmUnit
                })
                this.moveY = 0
            }

        },
        // 拖入控件
        onDragStart(item, event) {
            this.dragData = item
            if (this.isDebug) {
                console.log(item, event)
            }
        },
        onDrop(event) {
            let rect = this.$refs['draw-block'].getBoundingClientRect()
            let point = {
                x: event.clientX,
                y: event.clientY
            }
            if ((rect.x < point.x && (rect.x + rect.width) > point.x)
                && (rect.y < point.y && (rect.y + rect.height) > point.y)) {
                let data = JSON.parse(JSON.stringify(this.dragData.model))
                data.attr.top = point.y - rect.y
                data.attr.left = point.x * 1 - rect.x * 1
                this.dataList.push(data)
                /*    console.log('push item:', data, this.dataList) */
            }

            if (this.isDebug) {
                /*  console.log('drop', event) */
            }
        },
        // 移动控件位置
        onMouseDown(item, event) {
            this.moveData = {
                item: item,
                point: {
                    x: event.clientX,
                    y: event.clientY
                }
            }
            if (this.isDebug) {
                /*  console.log(item, event) */
            }
        },
        onMouseMove(event) {
            if (!this.moveData.item) {
                return
            }
            this.moveTo(event)
            if (this.isDebug) {
                console.log(event)
            }
        },
        onMouseUp(event) {
            this.moveData = {
                item: false,
                point: false
            }
            if (this.isDebug) {
                console.log(event)
            }
        },
        // 选中控件
        chosenItem(index, event) {
            this.curIndex = index
            this.curDom = event.currentTarget
            /*  console.log(event.currentTarget) */
        },
        /**
         * 执行移动操作
         * 从上一点位置移动到event的位置
         */
        moveTo(event) {
            let point = this.moveData.point
            // 计算位移
            let x = event.clientX * 1 - point.x * 1
            let y = event.clientY * 1 - point.y * 1
            /*   console.log(x, y) */
            // 立即回写
            this.moveData.point = {
                x: event.clientX,
                y: event.clientY
            }

            let attr = this.moveData.item.attr
            // 计算偏移
            x = attr.left * 1 + x * 1
            y = attr.top * 1 + y * 1

            attr.left = x < 0 ? 0 : x
            attr.top = y < 0 ? 0 : y
        },
        onActiveItem(index) {
            this.curIndex = index
        },
        delControl() {
            this.dataList.splice(this.curIndex, 1)
            this.curIndex = -1
        },
        // 图片上传
        delFile(fileIndex) {
            this.fileList.splice(fileIndex, 1)
            this.dataList[this.curIndex].value = ''
        },
        uploadSuccess(data) {
            this.fileList = [data]
            this.dataList[this.curIndex].value = data.fileUrl
        },
        setQrCode() {
            let item = this.dataList[this.curIndex]
            let val = item.value
            let isEmpty = !val
            if (item.dataAttr.type === 'custom') {
                val = JSON.stringify(item.dataAttr.dataSource)
                isEmpty = item.dataAttr.dataSource.length === 0
            }
            // 获取第一个元素
            let childs = this.curDom.childNodes
            let dom = this.curDom.children[0]
            childs = dom.children;
            for (let i = childs.length - 1; i >= 0; i--) {
                /*  console.log(childs[i].nodeName) */
                if (childs[i].nodeName != 'SPAN') {
                    dom.removeChild(childs[i]);
                }
            }
            if (!isEmpty) {
                let code = new QRCode(dom, {
                    text: val,
                    width: this.dataList[this.curIndex].attr.width * this.cmUnit,
                    height: this.dataList[this.curIndex].attr.width * this.cmUnit,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })
                this.curDom.coder = code
            }
        },
        submitTicket() {
            let msg = false
            if (!this.form.templateName) {
                msg = '模板名称不能为空'
            } else if (!this.dataList.length) {
                msg = '内容不能为空'
            }
            if (msg) {
                this.$message.warning(msg)
                return
            }
            let params = {
                ...this.form, content: JSON.stringify({
                    dataList: this.dataList,
                    canvasSize: this.canvasSize
                })
            }
            console.log(params);
            saveOrUpdateTicketTemplate(params).then(res => {
                console.log(res)
                this.$message.success("发布成功")
                // this.$router.go(-1)
            })
        },
        print() {
            let print = this.$refs['draw-block'].innerHTML  //获取目标区域
            const hiprintTemplate = new this.$pluginName.PrintTemplate();
            //模板对象获取打印机列表
            const printerList_ = hiprintTemplate.getPrinterList();
            if (window.hiwebSocket.opened === false) {
                this.$message.warning("未启动打印服务，使用浏览器打印方式！");
                const iframeDom = document.createElement('iframe')
                const attrObj = {
                    height: 0,
                    width: 0,
                    border: 0,
                    id: 'iframe'
                }
                const styleObj = {
                    position: 'fixed',
                    'z-index': '-999',
                }
                Object.entries(attrObj).forEach(([key, value]) => iframeDom.setAttribute(key, value))
                Object.entries(styleObj).forEach(([key, value]) => { iframeDom.style[key] = value })
                document.body.appendChild(iframeDom);
                const iframeDocs = iframeDom.contentWindow.document
                iframeDocs.write(print)
                console.log(print);
                iframeDocs.body.style.margin = '0px'
                iframeDocs.getElementsByTagName('div')[0].style.borderWidth = 0
                window.setTimeout(function () {
                    iframeDom.contentWindow.print()
                    document.body.removeChild(iframeDom)
                }, 500)
            } else {
                let printIndex = printerList_.findIndex(item => item.name == this.printerName);
                let printerName = printIndex == -1 ? "" : this.printerName;
                console.log(print);
                hiprintTemplate.printByHtml2(print, {
                    printer: printerName, // 打印机名称，不填则默认打印机
                    title: "任务队列中名称",
                }); //直接打印，需要安装客户端 下面会提到客户端的安装
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.pages_content {
    padding: 10px;
}

.header-area {
    margin: 10px 0;

    .el-button {
        float: right;
    }
}

.flex {
    display: flex;

    .flex-item {
        flex: 1;
        margin: 0 5px;
    }

    .flex-1 {
        width: 100px;
    }

    .flex-2 {
        width: 150px;
    }
}

.header-title {
    background: #ddd;
    line-height: 3;
    padding-left: 10px;
    border-right: 1px solid #fff;
}

.operation-area {
    padding: 10px;

    .control-item {
        line-height: 2;
        text-align: center;
        margin: 5px 0;
        background: #15964f;
        cursor: pointer;
        color: #fff;
    }

    .ticket-item {
        padding: 10px;
        border-width: 1px;
        display: inline;
        position: absolute;
    }

    .ticket-item:hover {
        padding: 10px;
        border: 1px dashed #ddd;
        cursor: all-scroll;
        display: inline;
    }

    .active-item {
        border: 1px solid #f32403 !important;
    }

    .div:focus {
        border: 1px solid #f32403 !important;
    }

}

.el-checkbox {
    margin-left: 20px;
    display: block;
    line-height: 1;
}

.canvas-area {
    background-image: linear-gradient(90deg, rgba(200, 0, 0, 0.15) 10%, rgba(0, 0, 0, 0) 10%), linear-gradient(rgba(200, 0, 0, 0.15) 10%, rgba(0, 0, 0, 0) 10%);
    background-size: 10px 10px;
}

.canvas-input {
    width: 100px;
}

.bottom_all {
    float: right;
    margin-right: 10px;
    margin-top: 5px;
}

.el-button--danger:focus,
.el-button--danger:hover {
    background: #f06464;
    border-color: #f06464;
    color: #FFF;
}
</style>